import React from "react";
import "./AvailableSection.css";

function AvailableSection() {
  const brands = [
    "/brands/amz.png",
      "/brands/flip.png",
        "/brands/amz.png",
      "/brands/flip.png",
        "/brands/amz.png",
      "/brands/flip.png",
        "/brands/amz.png",
      "/brands/flip.png",
        "/brands/amz.png",
      "/brands/flip.png",
      
  ];

  return (
    <section className="available-section">
      <div className="available-container">
        <h2>We Are Also Available On</h2>
        <p>Shop Vedonica on your favorite marketplaces</p>

        <div className="logo-slider">
          <div className="logo-track">
            {brands.map((item, index) => (
              <div className="logo-card" key={index}>
                <img src={item} alt="brand" />
              </div>
            ))}

            {brands.map((item, index) => (
              <div className="logo-card" key={`dup-${index}`}>
                <img src={item} alt="brand" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AvailableSection;